import React from "react";

const NotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <h1 style={{ fontSize: "64px", fontFamily: "Display" }}>404</h1>
      <h3 style={{ fontFamily: "Display" }}>Page Not Found</h3>
    </div>
  );
};

export default NotFound;
